import { render } from "./tinymce.vue?vue&type=template&id=21581494"
import script from "./tinymce.vue?vue&type=script&setup=true&lang=js"
export * from "./tinymce.vue?vue&type=script&setup=true&lang=js"

import "./tinymce.vue?vue&type=style&index=0&id=21581494&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/tinymce.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21581494"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21581494', __exports__)) {
    console.log('reload')
    api.reload('21581494', __exports__)
  }
  
  module.hot.accept("./tinymce.vue?vue&type=template&id=21581494", () => {
    console.log('re-render')
    api.rerender('21581494', render)
  })

}


export default __exports__